import React from 'react';
import { formatId } from '../../utils/shortid';

const MedicalHistory = ({ patient, medicalHistory, onClose }) => {
  return (
    <div className="p-6">
      <div className="flex justify-between items-start">
        <h3 className="text-lg font-bold text-gray-900">
          Medical History - {patient.name}
        </h3>
        <button 
          onClick={onClose}
          className="text-gray-400 hover:text-gray-500"
        >
          <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      
      <div className="mt-4">
        {medicalHistory.length === 0 ? (
          <p className="text-gray-500 text-center py-4">No medical history available</p>
        ) : (
          <div className="space-y-6">
            {medicalHistory.map((record) => (
              <div key={record.id} className="bg-gray-50 p-4 rounded-lg">
                <div className="flex items-center justify-between mb-3">
                  <div>
                    <span className="text-sm font-medium text-gray-900">Visit Date: {record.date}</span>
                    <span className="ml-4 text-xs text-gray-500">Appointment ID: {formatId(record.id)}</span>
                  </div>
                  <span className="text-sm text-gray-500">{record.department}</span>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <p className="text-xs font-medium text-gray-500">Doctor</p>
                    <p className="text-sm text-gray-900">{record.doctor}</p>
                  </div>
                  <div>
                    <p className="text-xs font-medium text-gray-500">Diagnosis</p>
                    <p className="text-sm text-gray-900">{record.diagnosis}</p>
                  </div>
                  <div>
                    <p className="text-xs font-medium text-gray-500">Prescription</p>
                    <p className="text-sm text-gray-900">{record.prescription}</p>
                  </div>
                  <div>
                    <p className="text-xs font-medium text-gray-500">Notes</p>
                    <p className="text-sm text-gray-900">{record.notes}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      
      <div className="mt-6 flex justify-end">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default MedicalHistory;
